import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';
import { environment } from 'environments/environment';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { takeUntil } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class SignalRService {

    private hubConnection!: signalR.HubConnection;
    private inwardUpdate$ = new Subject<void>();
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    user: User;

    /**
     *
     */
    constructor(_userService: UserService) {
        _userService.user$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((user: User) => {
                this.user = user;
            });

    }

    inwardUpdates$ = this.inwardUpdate$.asObservable();

    startConnection(): void {
        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(
                environment.baseUrl.substring(0, environment.baseUrl.lastIndexOf('/api')) + '/notify'
            )
            .withAutomaticReconnect()
            .build();

        this.hubConnection.start()
            .catch(err => console.error('SignalR error:', err));

        this.hubConnection.on("SendOffersToUser", (response) => {
            if (response.notificationType == 6) {
                if (response.data === this.user.id) {
                    this.inwardUpdate$.next(); // notify app
                }
            }
        });
    }
}
